const PHONE_TYPE = {
  MOBILE: 'Mobile',
  OFFICE_PHONE: 'Office Phone',
};

export default PHONE_TYPE;
